<template>
    <div>
        <vSelect :options="seasonOptions" v-model="season" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';


export default {
    name: "SeasonSelect",
    components: {
        vSelect
    },
    props: {
        value: String
    },
    computed: {
        seasonOptions: function() {
            var ret = [];
            if( this.listData )
                for( var a of this.listData ) {
                    var id = a.id
                    var explanation = a.id != null ? a.id : ""
                    ret.push({code: a.id, label: id +" :  " + explanation })
                }
            return ret;
        },
        season: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        },
        listData() {
            return this.$store.state.timetable.seasons.list;
        },     
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
    },
    mounted() {
         if(!this.listData || this.listData.length === 0) 
             this.$store.dispatch('timetable/getSeasonList')
    }
}
</script>